import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { toggleEnableReturnLocation } from '../../../actions/carActions';
import Helper from '../../modules/Helper';
import Checkbox from '../Common/Checkbox';

type EnableReturnLocationCheckboxProps = {
	enableReturnLocation: boolean;
	toggleEnableReturnLocation: (toggle: boolean) => void;
};
const EnableReturnLocationCheckbox: FC<EnableReturnLocationCheckboxProps> = (props) => {
	const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const checked = event.target.checked;
		props.toggleEnableReturnLocation(checked);
	};

	useEffect(() => {
		if (Helper.checkQueryStringKeyValue('pickup', '1')) {
			props.toggleEnableReturnLocation(true);
		}
		const parsed = Helper.parseQueryString(window.location.search, true);
		if (parsed.destcode) {
			props.toggleEnableReturnLocation(true);
		}
	}, []);

	return (
		<div className="d-xl-block d-none">
			<Checkbox
				checked={props.enableReturnLocation}
				label={Helper.trans('main.cars.returnToDifferentLocation')}
				id="return-location"
				onChange={onChange}
			/>
		</div>
	);
};

// @ts-ignore
const mapStateToProps = (state) => ({
	enableReturnLocation: state.car.enableReturnLocation,
});

export default connect(mapStateToProps, { toggleEnableReturnLocation })(EnableReturnLocationCheckbox);
